/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Select_Folder_TitleInputs */



/**
* | output |
* | --- |
* | "Export Audio Description - Select Folder" |
*
* @param {Audio_Description_Export_Select_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_select_folder_title = /** @type {((inputs?: Audio_Description_Export_Select_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Select_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter la description audio - sélectionner un dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiobeschreibung exportieren – Ordner auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta descrizione audio - Seleziona cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт аудиоописания - Выберите папку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar descripción de audio - Seleccionar carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出音频描述 - 选择文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声説明のエクスポート - フォルダの選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो विवरण निर्यात करें - फ़ोल्डर चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar descrição de áudio - Selecionar pasta")
	return /** @type {LocalizedString} */ ("Export Audio Description - Select Folder")
});